var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.pretty)+" ")]):_c('span',{staticStyle:{"cursor":"not-allowed"}},[_vm._v(" "+_vm._s(_vm.pretty)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }